import { t } from '../../i18n.js';
import {showValidationErrors, reportRequestError, hasFieldErrors} from "../../utils/formHelpers";
import {logClientEvent} from "../../utils/jsErrorLogger.js";
import {isCodeOkUserNotFound} from '../authState.js';

export default function bookingSms({$, api, state, data, routes, emit, sharedState, onNext, onComplete, onSaveState}) {

    let autoSubmit = true;
    let resendTimeoutId = null;

    function render() {
        const $el = $(`
        <div class="booking-sms-row active" data-auth-step='booking-sms'>
            <button class="login-close-button auth-back-btn" data-step="booking-phone">&times;</button>
            <h3>${t('confirmPhoneTitle')}</h3>
            <p>${t('confirmPhoneSubTitle')}</p>
            <form class="booking-sms-form">
                <div class="form-row">
                    <label>${t('verification_code')}</label>
                    <div class="sms-code-container" id="smsCodeWrapper">
                        <input autocomplete="off" type="text" name="digits[]" class="sms-digit" pattern="[0-9]*" inputmode="numeric" maxlength="1" />
                        <input autocomplete="off" type="text" name="digits[]" class="sms-digit" pattern="[0-9]*" inputmode="numeric" maxlength="1" />
                        <input autocomplete="off" type="text" name="digits[]" class="sms-digit" pattern="[0-9]*" inputmode="numeric" maxlength="1" />
                        <input autocomplete="off" type="text" name="digits[]" class="sms-digit" pattern="[0-9]*" inputmode="numeric" maxlength="1" />
                        <input autocomplete="off" type="text" name="digits[]" class="sms-digit" pattern="[0-9]*" inputmode="numeric" maxlength="1" />
                        <input type="hidden" name="sms-code-value" value="" id="bookingSMS" />
                    </div>
                    <p class="field-error field-sms-error" style="display:none;">${t('incorrect_code')}</p>
                    <p class="hidden-input-value"></p>
                </div>
                <div class="form-actions">
                    <button type="submit">${t('submit_code')}</button>
                    <span id="resendSMS">${t('resend_code')}</span>
                </div>
            </form>
        </div>
        `);

        $el.find('#smsCodeWrapper').letteringInput({
            inputClass: 'sms-digit',
            hiddenInputWrapperID: 'smsCodeWrapper',
            hiddenInputName: 'sms-code-value',
            forbiddenKeyCodes: [],
            onLetterKeyup: function ($item, event) {
                console.log($item, event);
            },
            onSet: function ($e, event, value) {
                console.log("$e", $e);
                console.log("event", event);
                console.log("value", value);
                let val = $('input[name="sms-code-value"]', '#smsCodeWrapper').val();
                console.log("val:", val )
                $('.hidden-input-value').text(val);
                $el.find('.field-sms-error, .field-generic-error').hide();

                if (val && val.length > 0) {
                    const inputs = $el.find('input.sms-digit');
                    if (val && val.length === inputs.length) {
                        $el.find('.form-actions button').removeClass('disabled');
                        // auto submit - do this once.
                        if(autoSubmit) {
                            autoSubmit = false;
                            validateCode($el);
                        }
                    } else {
                        $el.find('.form-actions button').addClass('disabled');
                    }
                }
            },
        });

        $el.find('.booking-sms-form').on('submit', e => {
            e.preventDefault();
            validateCode($el);
        });

        const resendBtn = $el.find('#resendSMS');

        resendBtn.on('click', e => {
            e.preventDefault();
            resendBtn.attr('disabled', 'disabled');
            const phone = sharedState.phone;
            // Same picker country as the first send, so a prefix-less number resolves the same way.
            const phone_country = sharedState.phoneCountry;
            if(sharedState.noAccount) {
                if(data.skipValidate) {
                    // Obiect gol, nu nimic: complete({user}) destructura undefined și arunca TypeError.
                    onComplete({});
                } else {
                    getCode($el, routes.generateCode, { phone, phone_country });
                }
            } else if (sharedState.codeViaGuest || (sharedState.registeredId && !data.isAuth)) {
                // Codul a plecat pe ruta de oaspete (validatePhone a dat 404 — pagină „logată” fără
                // sesiune pe server, vezi authPhone.getCode); retrimiterea ia același drum.
                // Just registered = no session user yet, so validatePhone would 404 here too.
                sharedState.codeViaGuest = true;
                getCode($el, routes.generateCode, { phone, phone_country });
            } else {
                let email = sharedState.email;
                getCode($el, routes.validatePhone, { phone, email, phone_country, resend: 'yes' });
            }
        }).hide();

        hideAndShowResendBtn(resendBtn);

        return $el;
    }

    function hideAndShowResendBtn(resendBtn) {
        // Clear any existing timeout
        if (resendTimeoutId !== null) {
            clearTimeout(resendTimeoutId);
            resendTimeoutId = null;
        }

        // Hide the button immediately
        resendBtn.hide();

        // Set a new timeout to show it in 60 seconds
        resendTimeoutId = setTimeout(() => {
            resendBtn.show();
            resendTimeoutId = null;
        }, 60000);
    }

    function validateCode($el) {
        const value = $el.find('input[name="sms-code-value"]').val();
        if (value && value.length > 0) {
            const inputs = $el.find('input.sms-digit');
            if (value && value.length === inputs.length) {
                // `payload`, nu `data`: aici `data` sunt flag-urile de auth ale pasului (skipValidate),
                // iar atribuirea veche le suprascria.
                const payload = {
                    code: value,
                    phone: sharedState.phone,
                    // the code row was keyed under this country (see authPhone); harmless when unset
                    phone_country: sharedState.phoneCountry,
                };
                // Re-auth de la Finalize pe o pagină care era logată (nu oaspete): trimitem emailul
                // chiar dacă SMS-ul a plecat pe ruta de oaspete. Cu cod corect și fără sesiune, serverul
                // loghează contul cu acel email + telefon → rezervarea se leagă de cont, iar
                // reprogramarea / abonamentul (login_required) merg pe loc.
                const restoreLogin = !!data.reauth && !!sharedState.email
                    && !sharedState.noAccount && !state.noAccount;
                // Pe drumul de oaspete NU trimitem email: fără sesiune, serverul ar căuta un utilizator
                // cu email + telefon EXACT, iar un cont Google are telefonul NULL → 404 afișat ca
                // „cod incorect” la nesfârșit (review 9 sept 2026). Fără email, serverul verifică doar
                // telefon + cod și ține telefonul validat în sesiune, exact ce consumă Finalize.
                // „Continuă fără cont” e tot drum de oaspete (codul a plecat pe generateCode), chiar dacă
                // emailul a rămas în sharedState din sămânța de re-auth / din booking-init.
                if(sharedState?.email && !sharedState.noAccount && (!sharedState.codeViaGuest || restoreLogin)) {
                    payload.email = sharedState.email;
                }
                // Just registered on this page: register does not log in, the correct code does.
                // Send the new account's id (what the home page sends from localStorage) even on the
                // guest route - without an id or email the server only proves the phone, so the
                // account stays unverified and logged out and the booking is stored as a guest.
                if (sharedState.registeredId && !data.isAuth && !sharedState.noAccount) {
                    payload.id = sharedState.registeredId;
                }
                const onCodeError = (err) => {
                    console.warn(err);
                    if (err?.status === 429) {
                        // AuthLimiter: prea multe coduri greșite → {errors: {code: [msg]}}. Pasul n-are
                        // input `code`, deci textul ajunge în slotul generic. Fără reîncercare automată.
                        reportRequestError($el, err, 'sms');
                        return;
                    }
                    // 404 = cod greșit (validateCode caută telefon + cod). Orice altceva (5xx,
                    // rețea) NU e „cod incorect”: mesaj generic + log, ca omul să știe să reîncerce.
                    if (err?.status === 404 || hasFieldErrors(err)) {
                        $el.find('.field-sms-error').show();
                        return;
                    }
                    reportRequestError($el, err, 'sms');
                };
                api.get(routes.validateCode, {
                    data: payload,
                    success: (res) => {
                        onComplete(res);
                    },
                    error: (err) => {
                        // Cod corect, dar niciun cont cu emailul + telefonul ăsta (telefon schimbat în
                        // ecranul de re-auth, cont Google cu telefon NULL): o singură reverificare fără
                        // email, care ține telefonul validat în sesiune (codurile nu se consumă).
                        // Doar pe 404 CU {message}; 404 gol = cod greșit, 429 = plafon → fără buclă.
                        // Nelegat de restoreLogin: ORICE verificare care a trimis email și a primit „cod
                        // corect, cont negăsit” (sesiunea a murit între SMS și cod) rămânea blocată pe
                        // „cod incorect” cu codul bun. Reîncercarea are onCodeError, deci nu reîncearcă iar.
                        if ((payload.email || payload.id) && isCodeOkUserNotFound(err)) {
                            logClientEvent({message: 'auth request failed', status: 404, step: data.reauth ? 'reauth-login-miss' : 'code-login-miss'});
                            api.get(routes.validateCode, {
                                data: {code: payload.code, phone: payload.phone, phone_country: payload.phone_country},
                                success: (res) => onComplete(res),
                                error: onCodeError
                            });
                            return;
                        }
                        onCodeError(err);
                    }
                });
            }
        }
    }

    function getCode($el, url, param) {
        const resendBtn = $el.find('#resendSMS');

        api.post(url, {
            data: param,
            success: (data) => {
                $el.find('.field-generic-error').hide(); // un „nu am putut trimite” anterior nu mai e valabil
                resendBtn.removeAttr('disabled');
                hideAndShowResendBtn(resendBtn);
            },
            error: (err) => {
                reportRequestError($el, err, 'sms');
                resendBtn.removeAttr('disabled');
            }
        })
    }

    return {render};
}